import "./tile-fields.scss";

import * as React from "react";

import {cs} from "@common/react/chain-services";
import {provideContext} from "@common/react/context";
import {scope} from "@common/react/scope";

import {Expandable} from "../../../../../../../common/expandable/expandable";

import {getTileActionsUpdated} from "../actions/get-tile-actions-updated";
import {getTileFields} from "./common/get-tile-fields";
import {SingleFieldWell} from "./common/single-field-well/single-field-well";
import {updateSingleFieldInTile} from "./common/update-tile";

export const SingleKPIFields = ({tile, isSubTile, tileActions, debugFunction, next}) =>
    cs(
        [
            "tileFields",
            ({}, next) =>
                next(
                    getTileFields({
                        tile: tile.value,
                        measureSingleAttrs: ["valueField"],
                    })
                ),
        ],
        ({tileFields}, next) => provideContext("tileFields", tileFields, next),

        [
            "valueField",
            (_, next) =>
                SingleFieldWell({
                    field: scope(tile, ["valueField"]),
                    $type: "MeasureTileField",
                    label: "Value",
                    hideDisplayName: true,
                    hideSort: true,
                    onUpdateTile: (newVal, oriVal) =>
                        updateSingleFieldInTile({
                            fieldAttr: "valueField",
                            fieldVal: {newVal, oriVal},
                            tile,
                            updateTileActions: getTileActionsUpdated,
                        }),
                    next,
                }),
        ],
        [
            "fieldsSection",
            ({valueField}, next) =>
                next({
                    render: () =>
                        Expandable({
                            label: "Fields",
                            render: () => <>{valueField.render()}</>,
                        }),
                    override: valueField.override,
                }),
        ],

        ({fieldsSection}) =>
            next({
                render: () => (
                    <div className="tile-fields-3vr">
                        {fieldsSection.render()}
                        {tileActions?.render?.()}
                        {isSubTile && debugFunction?.render?.({})}
                    </div>
                ),
                override: fieldsSection.override || debugFunction?.override() || tileActions?.override({fieldType: "MeasureTileField"}),
                overrideAll: debugFunction?.overrideAll || tileActions?.overrideAll,
            })
    );
